import { checkResponse, myReplacer } from "src/components/js/statics1";
import returnMessageClass from "../system/returnMessageClass";

/// save or add keikkaLaskuRivi or keikkaLaskuPohjaRivi to db
export async function keikkaLaskuRivi_saveToDB(keikkaLaskuRivi, token) {
  try {
    const replacerWrapper = (key, value) => myReplacer(key, value);
    if (keikkaLaskuRivi.isUnknown) {
      // ei ole lasku eikä pohja tai on molemmat
      console.log("keikkaLaskuRivi.isUnknown");
      return false;
    }
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`,
      },
      body: JSON.stringify(keikkaLaskuRivi, replacerWrapper, 2),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/laskutus/laskuRivi/save",
      requestOptions
    );
    const cResponse = await checkResponse(response, "keikkaLaskuClass:saveKeikkaLaskuRiviToDB");
    return cResponse.success;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function keikkaLaskuPohjaRivi_saveToDB(keikkaLaskuRivi, token) {
  return await keikkaLaskuRivi_saveToDB(keikkaLaskuRivi, token);
}

export async function keikkaLaskuRivi_delete(keikkaLasku, keikkaLaskuRiviId, token) {
  const returnMessage = new returnMessageClass("keikkaLaskuClass.keikkaLaskuRivi_delete()");
  try {
    // remove from keikkaLasku array
    if (keikkaLasku) {
      const index = keikkaLasku.keikkaLaskuRivit.findIndex(
        (rivi) => rivi.keikkaLaskuRiviId == keikkaLaskuRiviId
      );
      if (index > -1) keikkaLasku.keikkaLaskuRivit.splice(index, 1);
    }

    // send delete request to server
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`,
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL +
      "/api/keikka/laskutus/laskuRivi/delete/" +
      keikkaLaskuRiviId,
      requestOptions
    );
    returnMessage.success = response.status == 200;
    returnMessage.message = await response.text();
    return returnMessage;
  } catch (error) {
    console.log(error);
    returnMessage.message = "Laskurivin poisto epäonnistui";
    returnMessage.error = error;
    return returnMessage;
  }
}
export async function keikkaLaskuRivi_deleteAll(keikkaLasku, token) {
  const returnMessage = new returnMessageClass("keikkaLaskuClass.keikkaLaskuRivi_deleteAll()");
  try {
    // remove from keikkaLasku array
    if (keikkaLasku) {
      keikkaLasku.keikkaLaskuRivit = [];
    }

    // send delete request to server
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`,
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL +
      "/api/keikka/laskutus/laskuRivi/deleteAll/" +
      keikkaLasku.keikkaLaskuId,
      requestOptions
    );
    returnMessage.success = response.status == 200;
    returnMessage.message = await response.text();
    return returnMessage;
  } catch (error) {
    console.log(error);
    returnMessage.message = "Laskurivien poisto epäonnistui";
    returnMessage.error = error;
    return returnMessage;
  }
}

export function keikkaLaskuRivi_getSumEur(keikkaLaskuRivi) {
  const alennus = keikkaLaskuRivi.alennus;
  const määrä = keikkaLaskuRivi.määrä;
  const hinta = keikkaLaskuRivi.hinta;
  const amount = Math.round(määrä * hinta * 100) / 100;
  // subtract alennus
  const tot = Math.round(amount * (1 - alennus / 100) * 100) / 100;
  return tot;
}
